import { render, staticRenderFns } from "./BoxSnsItem.vue?vue&type=template&id=06fde32f&scoped=true&"
import script from "./BoxSnsItem.vue?vue&type=script&lang=ts&"
export * from "./BoxSnsItem.vue?vue&type=script&lang=ts&"
import style0 from "./BoxSnsItem.vue?vue&type=style&index=0&id=06fde32f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fde32f",
  null
  
)

export default component.exports